import { render, staticRenderFns } from "./IpHandler.vue?vue&type=template&id=2a0a4f07"
import script from "./IpHandler.vue?vue&type=script&lang=ts"
export * from "./IpHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports